// extracted by mini-css-extract-plugin
module.exports = {"content":"News_content__bFmGK","news":"News_news__ts2SP","item":"News_item__q2-BC"};